import accesCourtsExt from "../../../assets/img/img-installations/accesCourtsExterieurs.png";
import accesCourtsCouv from "../../../assets/img/img-installations/accesCourtsCouverts.png";

const tabOuSommesNous = [
  { id: "accesCourtsExt", image: accesCourtsExt },
  { id: "accesCourtsCouv", image: accesCourtsCouv },
];

export default tabOuSommesNous;
